import React from "react";
import HeaderProviders from "../HeaderProviders/index";

import css from "../ProviderPage/ProviderPage.module.css";

function ProviderPage({ providerDisplay = {} }) {
  const {
    UKPRN,
    name,
    sort_code,
    acc_no,
    contracts,
    firstname,
    surname,
    email,
    telephone,
    job_title
  } = providerDisplay;
  return (
    <div className={css.providerGridContainer}>
      <div className={css.providerHeader}>
        <HeaderProviders />
      </div>
      <div className={css.autocompleteProviders}>
        <h3>{name}</h3>
        <p>{UKPRN}</p>
        <p>{sort_code}</p>
        <p>{acc_no}</p>
        <p>{contracts}</p>
        <p>{firstname}</p>
        <p>{surname}</p>
        <p>{email}</p>
        <p>{telephone}</p>
        <p>{job_title}</p>
      </div>
    </div>
  );
}

export default ProviderPage;
